<svg width="89" height="88" viewBox="0 0 89 88" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M49.2671 29.7367L54.1072 39.4167C54.7672 40.7367 56.5272 42.0567 57.9938 42.2767L66.7572 43.7433C72.3672 44.6967 73.6871 48.73 69.6538 52.7634L62.8339 59.5834C61.6972 60.72 61.0371 62.9567 61.4038 64.57L63.3472 73.04C64.8872 79.7134 61.3306 82.3167 55.4272 78.8334L47.2138 73.9567C45.7105 73.0767 43.2906 73.0767 41.7872 73.9567L33.5738 78.8334C27.6705 82.3167 24.1138 79.7134 25.6538 73.04L27.5972 64.57C27.9639 62.9934 27.3039 60.7567 26.1672 59.5834L19.3472 52.7634C15.3139 48.73 16.6338 44.66 22.2438 43.7433L31.0072 42.2767C32.4739 42.02 34.2339 40.7367 34.8939 39.4167L39.7339 29.7367C42.3372 24.4934 46.6638 24.4934 49.2671 29.7367Z"
    stroke="#0F9D58"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M22.5 33.0002V7.3335"
    stroke="#0F9D58"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M66.5 33.0002V7.3335"
    stroke="#0F9D58"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M44.5 14.6668V7.3335"
    stroke="#0F9D58"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
